import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import chatHomeListCacheConfig from '@/client/exchanges/cacheExchange/chatHomeListCacheConfig';
import insertIntoCachedListBaseQueries from '@/client/exchanges/cacheExchange/insertIntoCachedListBaseQueries';
import type { ResultOf } from '@/gql/graphql';
import type { WatchChatPreferenceStream } from '@/hooks/useGlobalSubscriptions';
import { setNextCursor } from '@/stores/useSubscriptionStreamStore';

export default function chat_person_preference_stream(
  ...vars: [
    parent: {
      chat_person_preference_stream: ResultOf<
        typeof WatchChatPreferenceStream
      >['chat_person_preference_stream'];
    },
    args: unknown,
    cache: Cache,
    info: ResolveInfo,
  ]
) {
  const [parent, , cache] = vars;
  const preferences = parent.chat_person_preference_stream;
  const latestPreference = preferences[preferences.length - 1];

  if (!latestPreference) {
    return;
  }

  setNextCursor('chat_person_preference', latestPreference.updated_at);

  insertIntoCachedListBaseQueries(
    cache,
    preferences.map((preference) => preference.chat_id),
    chatHomeListCacheConfig,
  );
}
